import { useEffect } from 'react';

/**
 * Lock document scroll while a dialog/modal is open.
 * Force-clears overflow styles on cleanup so close/unmount races cannot leave
 * the page stuck. Pair with MUI `disableScrollLock` to avoid fighting ModalManager.
 * @param {boolean} locked
 */
export default function useLockBodyScroll(locked) {
  useEffect(() => {
    if (!locked) return undefined;
    const { documentElement: html, body } = document;
    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    html.style.overscrollBehavior = 'none';
    body.style.touchAction = 'none';
    return () => {
      html.style.overflow = '';
      body.style.overflow = '';
      html.style.overscrollBehavior = '';
      body.style.touchAction = '';
    };
  }, [locked]);
}
